/* Careatic — PDP: gallery, real-variant size selection (price/stock per size),
   qty, pincode check, sticky buy bar. Add to Cart / Buy Now submit the selected
   variant through the native cart so the Shiprocket Smart Cart (Fastrr express
   checkout) opens — same as the rest of the store. */
(function () {
  'use strict';
  function money(cents) { return '₹' + Math.round(cents / 100).toLocaleString('en-IN'); }

  function init() {
    /* ---- Gallery ---- */
    var gal = document.querySelector('[data-ca-gallery]');
    if (gal) {
      var slides = Array.prototype.slice.call(gal.querySelectorAll('[data-ca-gal-slide]'));
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-ca-gal-thumb]'));
      var countEl = gal.querySelector('[data-ca-gal-count]');
      var gi = 0;
      function show(n) {
        gi = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.setAttribute('data-active', k === gi); });
        thumbs.forEach(function (t, k) { t.setAttribute('data-active', k === gi); });
        if (countEl) countEl.textContent = (gi + 1) + ' / ' + slides.length;
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = gal.querySelector('[data-ca-gal-prev]'), next = gal.querySelector('[data-ca-gal-next]');
      if (prev) prev.addEventListener('click', function () { show(gi - 1); });
      if (next) next.addEventListener('click', function () { show(gi + 1); });
      var tx = null, main = gal.querySelector('.ca-gal__main');
      if (main && slides.length > 1) {
        main.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (tx == null) return;
          var dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 40) show(dx < 0 ? gi + 1 : gi - 1);
          tx = null;
        }, { passive: true });
      }
    }

    /* ---- Buy box ---- */
    var form = document.querySelector('[data-ca-pdp-form]');
    if (!form) return;
    var vid = form.querySelector('[data-ca-vid]');
    var chips = Array.prototype.slice.call(form.querySelectorAll('[data-ca-sizechip]'));
    var priceEl = document.querySelector('[data-ca-price]');
    var stockpill = document.querySelector('[data-ca-stockpill]');
    var stocknote = document.querySelector('[data-ca-stocknote]');
    var qtyVal = form.querySelector('[data-ca-qty-val]');
    var qtyInput = form.querySelector('[data-ca-qty-input]');
    var qtyDec = form.querySelector('[data-ca-qty-dec]');
    var buyLabel = form.querySelector('.ca-btn[data-ca-buy] span');
    var addLabel = form.querySelector('.ca-btn[data-ca-add] span');
    var sel = { id: '', price: 0, mrp: 0, size: '', soldout: false };
    var qty = 1;
    var bbPrice = document.querySelector('[data-ca-buybar-price]');
    var bbSize = document.querySelector('[data-ca-buybar-size]');
    var bbBuyLabel = document.querySelector('[data-ca-buybar-buy] span');

    function renderPrice() {
      if (!priceEl) return;
      var pct = (sel.mrp && sel.mrp > sel.price) ? Math.round((sel.mrp - sel.price) / sel.mrp * 100) : 0;
      var h = '<div class="ca-priceblock ca-priceblock--lg"><div class="ca-priceblock__row"><span class="ca-priceblock__sale">' + money(sel.price) + '</span>';
      if (sel.mrp && sel.mrp > sel.price) h += '<span class="ca-priceblock__mrp">' + money(sel.mrp) + '</span>';
      if (pct > 0) h += '<span class="ca-priceblock__flag">' + pct + '% OFF</span>';
      h += '</div>';
      if (sel.mrp && sel.mrp > sel.price) h += '<div class="ca-priceblock__save">You save ' + money(sel.mrp - sel.price) + '</div>';
      priceEl.innerHTML = h + '</div>';
    }
    function syncButtons() {
      // Price sits on Add to Cart; Buy Now stays label-only.
      if (addLabel) addLabel.textContent = sel.soldout ? 'Sold out in this size' : ('Add to Cart · ' + money(sel.price * qty));
      if (buyLabel) buyLabel.textContent = 'Buy Now';
      if (bbPrice) bbPrice.textContent = money(sel.price) + ' · incl. taxes';
      if (bbSize) bbSize.textContent = 'Size ' + sel.size;
      if (bbBuyLabel) bbBuyLabel.innerHTML = sel.soldout ? 'Sold out' : ('Buy Now<span class="ca-bb-price"> · ' + money(sel.price * qty) + '</span>');
    }
    function selectChip(chip) {
      sel.id = chip.getAttribute('data-vid');
      sel.price = parseInt(chip.getAttribute('data-price') || '0', 10);
      sel.mrp = parseInt(chip.getAttribute('data-mrp') || '0', 10);
      sel.size = chip.getAttribute('data-size') || '';
      sel.soldout = chip.getAttribute('data-soldout') === 'true';
      if (vid) vid.value = sel.id;
      chips.forEach(function (c) { c.setAttribute('data-active', String(c === chip)); });
      if (stockpill) {
        stockpill.textContent = sel.soldout ? 'Sold out' : 'In Stock';
        stockpill.classList.toggle('ca-stockpill--out', sel.soldout);
      }
      renderPrice();
      syncButtons();
      if (window.caTrack) window.caTrack('select_item', { variant: 'size_' + sel.size });
    }
    chips.forEach(function (chip) {
      var active = chip.getAttribute('data-active') === 'true';
      if (active) { sel.id = chip.getAttribute('data-vid'); sel.price = parseInt(chip.getAttribute('data-price') || '0', 10); sel.mrp = parseInt(chip.getAttribute('data-mrp') || '0', 10); sel.size = chip.getAttribute('data-size') || ''; sel.soldout = chip.getAttribute('data-soldout') === 'true'; }
      if (chip.getAttribute('data-soldout') !== 'true') chip.addEventListener('click', function () { selectChip(chip); });
    });
    syncButtons();

    /* ---- Qty ---- */
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyVal) qtyVal.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
      if (qtyDec) qtyDec.disabled = qty <= 1;
      syncButtons();
    }
    if (qtyDec) qtyDec.addEventListener('click', function () { setQty(qty - 1); });
    var qtyInc = form.querySelector('[data-ca-qty-inc]');
    if (qtyInc) qtyInc.addEventListener('click', function () { setQty(qty + 1); });
    setQty(1);

    /* ---- measure toggle ---- */
    var mt = document.querySelector('[data-ca-measure-toggle]'), mp = document.querySelector('[data-ca-measure]');
    if (mt && mp) mt.addEventListener('click', function () { mp.hidden = !mp.hidden; });

    /* ---- pincode (client stub; real serviceability via Shiprocket) ---- */
    var pinForm = document.querySelector('[data-ca-pincode]');
    if (pinForm) {
      pinForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var pin = (pinForm.querySelector('[data-ca-pin]').value || '').replace(/\D/g, '');
        var res = document.querySelector('[data-ca-pin-res]');
        res.hidden = false;
        if (!/^\d{6}$/.test(pin)) { res.textContent = '✗ Enter a valid 6-digit pincode'; res.style.color = 'var(--brand-primary)'; return; }
        if (window.caTrack) window.caTrack('pincode_check', { pin: pin });
        res.textContent = '✓ Deliverable · COD available · via Shiprocket';
        res.style.color = 'var(--text-secondary)';
      });
    }

    /* ---- intent + native submit (Add to Cart → slide cart) ---- */
    var intent = 'cart';
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ca-buy],[data-ca-add]');
      if (b) intent = b.hasAttribute('data-ca-buy') ? 'buy' : 'cart';
    }, true);
    form.addEventListener('submit', function () {
      if (window.caTrack) window.caTrack(intent === 'buy' ? 'begin_checkout' : 'add_to_cart', { size: sel.size, quantity: qty, value: Math.round(sel.price * qty / 100) });
    }, true);

    /* ---- Buy Now → Shiprocket (Fastrr) express checkout ----
       Adds the selected variant, then opens the same headless Fastrr checkout the
       slide cart uses. preventDefault stops the form submit (and the slide-cart
       interceptor) so Buy Now goes straight to checkout, not the drawer. */
    function srBuyNow(e) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var btn = e.currentTarget;
      var vid = sel.id || (form.querySelector('[name="id"]') || {}).value;
      if (!vid) return;
      if (btn) btn.classList.add('is-loading');
      var body = new FormData();
      body.append('id', vid);
      body.append('quantity', qty);
      function go() {
        if (window.caTrack) window.caTrack('begin_checkout', { size: sel.size, quantity: qty, value: Math.round(sel.price * qty / 100) });
        if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') {
          window.shiprocketCheckoutEvents.buyCart(e);
        } else {
          window.location.href = '/checkout';
        }
        if (btn) btn.classList.remove('is-loading');
      }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { return r.json(); })
        .then(go)
        .catch(function () { if (btn) btn.classList.remove('is-loading'); window.location.href = '/checkout'; });
    }
    form.querySelectorAll('[data-ca-buy]').forEach(function (b) {
      b.setAttribute('type', 'button');           // not a form submit anymore
      b.addEventListener('click', srBuyNow);
    });

    /* ---- sticky buy bar ---- */
    var bar = document.querySelector('[data-ca-buybar]');
    if (bar) {
      var onScroll = function () { bar.setAttribute('data-show', String(window.scrollY > 640)); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
      var bbBuy = bar.querySelector('[data-ca-buybar-buy]');
      if (bbBuy) bbBuy.addEventListener('click', function () {
        var realBuy = form.querySelector('.ca-btn[data-ca-buy]');
        if (realBuy) realBuy.click();
      });
    }

    if (window.caTrack) window.caTrack('view_item', { item_name: document.title });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
